<template>
  <div class="app-layout">
    <AppSidebar />
    <div class="app-layout__content">
      <AppCourseContextBar v-if="showCourseContext" />
      <router-view />
    </div>
  </div>
</template>

<script>
import AppSidebar from '../components/AppSidebar.vue';
import AppCourseContextBar from '../components/AppCourseContextBar.vue';
import { useActiveCalculationModule } from '../composables/useActiveCalculationModule';

export default {
  name: 'AppLayoutWithSidebar',
  components: {
    AppSidebar,
    AppCourseContextBar,
  },
  setup() {
    useActiveCalculationModule();
  },
  computed: {
    showCourseContext() {
      // Выбор курса и кабинет администратора — не про текущий расчёт.
      return this.$route.name !== 'courseSelection' && this.$route.name !== 'adminCabinet';
    },
  },
};
</script>

<style scoped>
.app-layout {
  display: flex;
  min-height: calc(100vh - 80px);
}

.app-layout__content {
  flex: 1;
  min-width: 0;
  padding: 1rem;
  background: var(--tcp-color-surface);
}
</style>
